/* Isolated Say Aloe native Shopify cart and video controls. */
(() => {
  'use strict';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  // Reuse the existing store-wide Yotpo Reviews tab. Keep the product link
  // as a no-JS / widget-unavailable fallback; do not recreate review content.
  document.querySelector('[data-open-reviews]').addEventListener('click', event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const trigger = document.querySelector('.yotpo-reviews-tab-floating-tab');
    if (!trigger) return;
    event.preventDefault();
    trigger.click();
  });

  const q = document.querySelector('#quantity');
  const less = document.querySelector('#less');
  const more = document.querySelector('#more');
  function setQuantity(value) {
    q.value = Math.min(99, Math.max(1, Math.floor(Number(value) || 1)));
    less.disabled = Number(q.value) === 1;
    more.disabled = Number(q.value) === 99;
  }
  less.addEventListener('click', () => setQuantity(Number(q.value) - 1));
  more.addEventListener('click', () => setQuantity(Number(q.value) + 1));
  q.addEventListener('change', () => setQuantity(q.value));
  setQuantity(q.value);

  const mainImage = document.querySelector('.main-product');
  const originalAlt = mainImage.alt;
  let imageChanged = false;
  mainImage.addEventListener('load', () => {
    if (!imageChanged || reducedMotion.matches || !mainImage.animate) return;
    mainImage.getAnimations().forEach(animation => animation.cancel());
    mainImage.animate([{ opacity: .65 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
  });
  document.querySelectorAll('[data-image]').forEach(button => {
    button.addEventListener('click', () => {
      imageChanged = true;
      mainImage.removeAttribute('srcset');
      mainImage.src = button.dataset.src;
      // Reuse supplied descriptions verbatim; new descriptive copy needs approval.
      const descriptions = {
        hero: originalAlt,
        texture: '',
        'ugc-01': document.querySelector('[data-video] > img').alt,
        lifestyle: document.querySelector('.editorial > img').alt
      };
      mainImage.alt = descriptions[button.dataset.image];
      document.querySelectorAll('[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  });

  const dialog = document.querySelector('#notice');
  function notice(text) {
    document.querySelector('#notice-copy').textContent = text;
    if (!dialog.open) dialog.showModal();
  }
  document.querySelector('#say-aloe-cart').addEventListener('submit', () => setQuantity(q.value));
  const player = document.createElement('video');
  player.controls = true;
  player.playsInline = true;
  player.preload = 'none';
  player.style.cssText = 'display:none;max-width:100%;width:360px;max-height:70vh;margin:0 auto 16px;background:#000';
  dialog.insertBefore(player, document.querySelector('#close-notice'));
  document.querySelectorAll('[data-video]').forEach(button => button.addEventListener('click', () => {
    if (!button.dataset.video) return;
    document.querySelector('#notice-copy').textContent = '';
    player.src = button.dataset.video;
    player.poster = button.querySelector('img').src;
    player.style.display = 'block';
    dialog.showModal();
    player.play().catch(() => {});
  }));
  dialog.addEventListener('close', () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
    player.style.display = 'none';
  });
  document.querySelector('#close-notice').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) {
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  }});

  const toggle = document.querySelector('#menu-toggle');
  const nav = document.querySelector('#nav');
  function setMenu(open) {
    nav.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', String(open));
  }
  toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && nav.classList.contains('open')) { setMenu(false); toggle.focus(); }
  });
  document.addEventListener('click', event => {
    if (!nav.contains(event.target) && !toggle.contains(event.target)) setMenu(false);
  });
  matchMedia('(min-width: 761px)').addEventListener('change', () => setMenu(false));

  // One dot per visible group, not one per card: mobile shows two videos at once.
  const grid = document.querySelector('.video-grid');
  const dots = document.querySelector('.dots');
  const cards = [...grid.querySelectorAll('[data-video]')];
  grid.id = 'campaign-video-grid';
  dots.setAttribute('role', 'group');
  dots.setAttribute('aria-labelledby', 'campaign-video-grid-heading');
  let stops = [];
  let dotButtons = [];
  function updateDots() {
    const nearest = stops.reduce((best, stop, index) => Math.abs(stop - grid.scrollLeft) < Math.abs(stops[best] - grid.scrollLeft) ? index : best, 0);
    dotButtons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === nearest)));
  }
  function buildDots() {
    const max = Math.max(0, grid.scrollWidth - grid.clientWidth);
    const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    const count = max > 2 ? Math.ceil((grid.scrollWidth + gap) / (grid.clientWidth + gap)) : 0;
    stops = Array.from({ length: count }, (_, index) => Math.min(index * (grid.clientWidth + gap), max));
    const gridLeft = grid.getBoundingClientRect().left;
    const cardStarts = cards.map(card => card.getBoundingClientRect().left - gridLeft + grid.scrollLeft);
    if (dotButtons.length !== count) {
      dotButtons = stops.map((stop, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'campaign-dot';
        button.setAttribute('aria-controls', grid.id);
        button.addEventListener('click', () => grid.scrollTo({ left: stops[index], behavior: reducedMotion.matches ? 'instant' : 'smooth' }));
        return button;
      });
      dots.replaceChildren(...dotButtons);
    }
    dotButtons.forEach((button, index) => {
      const card = cardStarts.reduce((best, start, i) => Math.abs(start - stops[index]) < Math.abs(cardStarts[best] - stops[index]) ? i : best, 0);
      // Reuse existing video titles verbatim instead of introducing new copy.
      button.setAttribute('aria-label', cards[card].querySelector('span').textContent.trim());
    });
    dots.classList.toggle('has-navigation', count > 1);
    updateDots();
  }
  let scrollFrame;
  grid.addEventListener('scroll', () => {
    cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(updateDots);
  }, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(buildDots).observe(grid);
  else window.addEventListener('resize', buildDots);
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) mainImage.getAnimations().forEach(animation => animation.cancel());
  });
  buildDots();
})();
